(function(){
    'use strict'; 
    angular.module('app').controller('RoutingMatrixController', RoutingMatrixController);
    RoutingMatrixController.$inject = [
        'RoutingMatrixTableService'
    ]; 

    function RoutingMatrixController(
        RoutingMatrixTableService
    ) {
        const vm = this; 

        init();

        function init() {
            vm.routingMatrixTable = new RoutingMatrixTableService().tableData;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/RoutingMatrixController.js